(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-crosssell"] && !Shopify.designMode) return;
  try {
    
/* Pide la seccion por la Section Rendering API y se reemplaza con el
   resultado. Si Shopify no devuelve recomendaciones, no queda nada. */
(() => {
  const load = (el) => {
    if (el.dataset.croXsellDone) return;
    el.dataset.croXsellDone = '1';
    fetch(el.dataset.url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-cro-xsell]');
        if (fresh) {
          /* Ya viene resuelto: que un shopify:section:load no lo vuelva a pedir. */
          fresh.dataset.croXsellDone = '1';
          el.replaceWith(fresh);
        }
        else el.remove();
      })
      .catch(() => el.remove());
  };

  const setup = () => {
    document.querySelectorAll('[data-cro-xsell]:not([data-cro-xsell-done])').forEach((el) => {
      if (!('IntersectionObserver' in window)) return load(el);
      const io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.disconnect();
          load(el);
        },
        { rootMargin: '600px' }
      );
      io.observe(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-header"] && !Shopify.designMode) return;
  try {
    
/* Los menus del header son <details>: solo uno abierto a la vez, y se
   cierran al hacer clic fuera o con Escape. */
(() => {
  const all = () => document.querySelectorAll('[data-cro-dd]');

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('[data-cro-dd] > summary');
    all().forEach((dd) => {
      if (summary && dd.contains(summary)) return;
      if (dd.contains(e.target)) return;
      dd.open = false;
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    all().forEach((dd) => {
      if (!dd.open) return;
      dd.open = false;
      dd.querySelector('summary')?.focus();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-hero"] && !Shopify.designMode) return;
  try {
    
/* Carrusel del banner: pista con translateX, una diapositiva por vista.
   Con menos de dos diapositivas no hace nada y el banner queda estatico. */
(() => {
  const init = (root) => {
    root.dataset.croHeroReady = '1';
    const track = root.querySelector('[data-cro-hero-track]');
    const slides = Array.from(root.querySelectorAll('[data-cro-hero-slide]'));
    if (!track || slides.length < 2) return;

    const dots = Array.from(root.querySelectorAll('[data-cro-hero-dot]'));
    const delay = parseInt(root.dataset.croHeroAutoplay || '0', 10);
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    let at = 0;
    let timer = null;

    const go = (n) => {
      at = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + at * 100 + '%)';
      slides.forEach((slide, k) => {
        const on = k === at;
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        /* Lo que no se ve tampoco recibe foco con el tabulador. */
        slide.querySelectorAll('a, button').forEach((el) => { el.tabIndex = on ? 0 : -1; });
      });
      dots.forEach((dot, k) => {
        if (k === at) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const play = () => {
      stop();
      if (!delay || still.matches) return;
      timer = setInterval(() => go(at + 1), delay);
    };

    root.querySelectorAll('[data-cro-hero-step]').forEach((btn) => {
      btn.addEventListener('click', () => { go(at + parseInt(btn.dataset.croHeroStep, 10)); play(); });
    });
    dots.forEach((dot, k) => dot.addEventListener('click', () => { go(k); play(); }));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));

    let from = null;
    root.addEventListener('touchstart', (e) => { from = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (from === null) return;
      const dx = e.changedTouches[0].clientX - from;
      if (Math.abs(dx) > 45) go(at + (dx < 0 ? 1 : -1));
      from = null;
      play();
    }, { passive: true });

    go(0);
    play();
  };

  const setup = () => {
    document.querySelectorAll('[data-cro-hero]:not([data-cro-hero-ready])').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product-cafe"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const qtyBtn = e.target.closest('[data-cpc-qty]');
  if (qtyBtn) {
    const input = qtyBtn.parentElement.querySelector('.cpc__qi');
    if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.cpcQty, 10));
    return;
  }

  const thumb = e.target.closest('[data-cpc-th]');
  if (thumb) {
    const gallery = thumb.closest('[data-cpc-gal]');
    if (!gallery) return;
    const main = gallery.querySelector('.cpc__img');
    if (main && thumb.dataset.cpcSrc) {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumb.dataset.cpcSrc;
      main.alt = thumb.querySelector('img')?.alt || main.alt;
    }
    const counter = gallery.querySelector('[data-cpc-i]');
    if (counter) counter.textContent = thumb.dataset.index;
    gallery.dataset.cpcIndex = String(Number(thumb.dataset.index) - 1);
    gallery.querySelectorAll('[data-cpc-th]').forEach((t) => t.classList.toggle('is-on', t === thumb));
    return;
  }

  const opener = e.target.closest('.cpc__stage--lb');
  if (opener) {
    cpcLbOpen(opener);
    return;
  }

  const lb = e.target.closest('[data-cpc-lb]');
  if (!lb) return;
  if (e.target.closest('[data-cpc-lb-close]')) {
    lb.close();
    return;
  }
  const step = e.target.closest('[data-cpc-lb-step]');
  if (step) {
    cpcLbGo(lb, cpcLbIndex(lb) + Number(step.dataset.cpcLbStep));
    return;
  }
  const go = e.target.closest('[data-cpc-lb-go]');
  if (go) {
    cpcLbGo(lb, Number(go.dataset.cpcLbGo));
    return;
  }
  if (!e.target.closest('.cpc-lb__frame') && !e.target.closest('.cpc-lb__thumbs')) lb.close();
});

/* Variantes: el radio real manda, la clase solo pinta el estado. */
document.addEventListener('change', (e) => {
  const radio = e.target.closest('.cpc__opt input[type="radio"]');
  if (!radio) return;
  radio.closest('.cpc__opts').querySelectorAll('.cpc__opt').forEach((l) => {
    l.classList.toggle('is-on', l.contains(radio) && radio.checked);
  });
});

document.addEventListener('keydown', (e) => {
  const opener = e.target.closest?.('.cpc__stage--lb');
  if (opener && (e.key === 'Enter' || e.key === ' ')) {
    e.preventDefault();
    cpcLbOpen(opener);
    return;
  }
  const lb = document.querySelector('[data-cpc-lb][open]');
  if (!lb) return;
  if (e.key === 'ArrowRight') cpcLbGo(lb, cpcLbIndex(lb) + 1);
  if (e.key === 'ArrowLeft') cpcLbGo(lb, cpcLbIndex(lb) - 1);
});

function cpcLbIndex(lb) {
  const on = lb.querySelector('.cpc-lb__item.is-on');
  return on ? Number(on.dataset.cpcLbItem) : 0;
}

function cpcLbGo(lb, index) {
  const items = lb.querySelectorAll('[data-cpc-lb-item]');
  if (!items.length) return;
  const next = (index + items.length) % items.length;
  items.forEach((el, i) => el.classList.toggle('is-on', i === next));
  lb.querySelectorAll('[data-cpc-lb-go]').forEach((el, i) => el.classList.toggle('is-on', i === next));
  const counter = lb.querySelector('[data-cpc-lb-i]');
  if (counter) counter.textContent = String(next + 1);
}

function cpcLbOpen(opener) {
  const section = opener.closest('.shopify-section');
  const gallery = opener.closest('[data-cpc-gal]');
  const lb = section && section.querySelector('[data-cpc-lb]');
  if (!lb) return;
  cpcLbGo(lb, Number((gallery && gallery.dataset.cpcIndex) || 0));
  lb.showModal();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const qtyBtn = e.target.closest('[data-cro-qty]');
  if (qtyBtn) {
    const input = qtyBtn.parentElement.querySelector('.cro-qty__i');
    if (input) {
      const next = (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.croQty, 10);
      input.value = Math.max(1, next);
    }
    return;
  }

  const thumb = e.target.closest('[data-cro-th]');
  if (thumb) {
    const gallery = thumb.closest('[data-cro-gal]');
    if (!gallery) return;
    const main = gallery.querySelector('.cro-gal__img');
    const counter = gallery.querySelector('[data-cro-gal-i]');
    if (main && thumb.dataset.croSrc) {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumb.dataset.croSrc;
      main.alt = thumb.querySelector('img')?.alt || main.alt;
    }
    if (counter) counter.textContent = thumb.dataset.index;
    gallery.dataset.croIndex = String(Number(thumb.dataset.index) - 1);
    gallery.querySelectorAll('[data-cro-th]').forEach((t) => t.classList.toggle('is-on', t === thumb));
    return;
  }

  const opener = e.target.closest('.cro-gal__main--lb');
  if (opener) {
    croLbOpen(opener);
    return;
  }

  const lb = e.target.closest('[data-cro-lb]');
  if (!lb) return;

  if (e.target.closest('[data-cro-lb-close]')) {
    lb.close();
    return;
  }
  const step = e.target.closest('[data-cro-lb-step]');
  if (step) {
    croLbGo(lb, croLbIndex(lb) + Number(step.dataset.croLbStep));
    return;
  }
  const go = e.target.closest('[data-cro-lb-go]');
  if (go) {
    croLbGo(lb, Number(go.dataset.croLbGo));
    return;
  }
  /* Clic fuera de la imagen: cerrar. */
  if (!e.target.closest('.cro-lb__frame') && !e.target.closest('.cro-lb__thumbs')) lb.close();
});

document.addEventListener('keydown', (e) => {
  const opener = e.target.closest?.('.cro-gal__main--lb');
  if (opener && (e.key === 'Enter' || e.key === ' ')) {
    e.preventDefault();
    croLbOpen(opener);
    return;
  }
  const lb = document.querySelector('[data-cro-lb][open]');
  if (!lb) return;
  if (e.key === 'ArrowRight') croLbGo(lb, croLbIndex(lb) + 1);
  if (e.key === 'ArrowLeft') croLbGo(lb, croLbIndex(lb) - 1);
});

/* Galeria a pantalla completa: abre en la imagen que el visor tenga
   seleccionada y da la vuelta al llegar a los extremos. */
function croLbIndex(lb) {
  const on = lb.querySelector('.cro-lb__item.is-on');
  return on ? Number(on.dataset.croLbItem) : 0;
}

function croLbGo(lb, index) {
  const items = lb.querySelectorAll('[data-cro-lb-item]');
  if (!items.length) return;
  const next = (index + items.length) % items.length;
  items.forEach((el, i) => el.classList.toggle('is-on', i === next));
  lb.querySelectorAll('[data-cro-lb-go]').forEach((el, i) => el.classList.toggle('is-on', i === next));
  const counter = lb.querySelector('[data-cro-lb-i]');
  if (counter) counter.textContent = String(next + 1);
}

/* La barra flotante de compra solo aparece cuando el boton principal ya no
   esta a la vista, para que nunca se vean los dos botones al mismo tiempo. */
(() => {
  const setup = () => {
    document.querySelectorAll('[data-cro-satc]').forEach((bar) => {
      if (bar.dataset.croSatcReady) return;
      const section = bar.closest('.shopify-section');
      const mainBtn = section && section.querySelector('[data-cro-atc-main]');
      if (!mainBtn) return;
      bar.dataset.croSatcReady = '1';

      if (!('IntersectionObserver' in window)) {
        bar.hidden = false;
        bar.classList.add('is-on');
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.hidden = false;
          bar.classList.toggle('is-on', show);
        },
        { threshold: 0 }
      );
      observer.observe(mainBtn);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', setup);
})();

function croLbOpen(opener) {
  const section = opener.closest('.shopify-section');
  const gallery = opener.closest('[data-cro-gal]');
  const lb = section && section.querySelector('[data-cro-lb]');
  if (!lb) return;
  croLbGo(lb, Number((gallery && gallery.dataset.croIndex) || 0));
  lb.showModal();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
